export type CalendarDay = {
  key: string;
  day: number;
  month: number;
  inside: boolean;
  future: boolean;
  value: string | null;
  level: number;
  present: boolean;
};
export function calendarDays(
  year: number,
  rows: { d0?: string | null; [key: string]: unknown }[],
  alias: string,
  count: boolean,
  today: string,
) {
  const values = new Map(
    rows
      .filter((r) => r.d0)
      .map((r) => [
        r.d0!.slice(0, 10),
        r[alias] == null ? null : String(r[alias]),
      ]),
  );
  const max = Math.max(
    1,
    ...[...values.values()]
      .filter((v) => v !== null)
      .map((v) => Math.abs(Number(v))),
  );
  const start = new Date(Date.UTC(year, 0, 1)),
    offset = (start.getUTCDay() + 6) % 7;
  start.setUTCDate(start.getUTCDate() - offset);
  const end = Date.UTC(year + 1, 0, 1),
    days: CalendarDay[] = [];
  for (
    let time = start.getTime();
    time < end || days.length % 7 !== 0;
    time += 86400000
  ) {
    const date = new Date(time),
      key = date.toISOString().slice(0, 10),
      inside = date.getUTCFullYear() === year,
      future = key > today,
      present = values.has(key);
    const value =
      inside && !future
        ? present
          ? values.get(key)!
          : count
            ? "0"
            : null
        : null;
    days.push({
      key,
      day: date.getUTCDate(),
      month: date.getUTCMonth(),
      inside,
      future,
      present,
      value,
      level:
        value === null
          ? 0
          : Number(value) === 0
            ? 1
            : Math.min(5, 2 + Math.floor((Math.abs(Number(value)) / max) * 3)),
    });
  }
  return Array.from({ length: days.length / 7 }, (_, i) =>
    days.slice(i * 7, i * 7 + 7),
  );
}
